export default __webpack_public_path__ + "static/media/gggg.0f44d2e1.png";